import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { GlobalServices } from 'src/app/shared/services/global.services';
import { GuestDetailModel, GuestModelSpa, HeaderModel, OneSignalNotificationModel } from 'src/app/shared/models/shared.model';
import { Observable, of, Subject } from 'rxjs';
import { distinctUntilChanged, filter, map, startWith, takeUntil } from 'rxjs/operators';
import { RestfullServices } from 'src/app/shared/services/restfull.services';
import { DatePipe, formatDate } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import * as introJs from 'intro.js';
import { SnackBarComponent } from 'src/app/shared/components/snack-bar/snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AlertDialogComponent } from 'src/app/shared/components/alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-add-reservation',
  templateUrl: './add-reservation.component.html',
  styleUrls: ['./add-reservation.component.scss']
})
export class AddReservationComponent implements OnInit {
  introJS = introJs.default();
  @Input() guestDetail: GuestDetailModel;
  @ViewChild(MatAutocompleteTrigger) _auto: MatAutocompleteTrigger;
  activeOption
  public guestForm: UntypedFormGroup;
  peopleOpt = [];
  reservationTime = [];
  tableNumberList = [];
  reservationStatus = [];
  months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
  days = ['Sun', 'Mon', 'Tues', 'Wed', 'Thu', 'Fri', 'Sat'];
  selectedTime: string;
  time: string;
  userGroup: GuestModelSpa[] = [];
  filteredUser: Observable<string[] | GuestModelSpa[]>;
  reservationId: any;
  guestId: any
  reservationDate: any
  guestName: string;
  currentStatus: string = "New Request";
  cancellationReason: string = "";
  previousStatus: string = "";
  restaurantName: string = "";
  public selectedIndex: any = 1;
  private destroy$ = new Subject<void>();

  public isCancelled: boolean = false;

  public cancellationReasonList: string[] = ["Time slot no longer available", "Duplicate or accidental booking", "Guest’s request", "Special event or private session scheduled", "Restaurant temporarily closed or under maintenance", "Other"]

  constructor(
    public globalService: GlobalServices,
    private fb: UntypedFormBuilder,
    private restfullServices: RestfullServices,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    if (this.activatedRoute.snapshot.queryParams.orderNumber) {
      this.router.navigate(['/pages/food-beverages/add-reservation'], {
        queryParams: {
          orderNumber: this.activatedRoute.snapshot.queryParams.orderNumber,
          restaurantId: this.activatedRoute.snapshot.queryParams.restaurantId
        }
      });
    }
    if (this.activatedRoute.snapshot.queryParams.id) {
      this.router.navigate(['/pages/food-beverages/add-reservation'], {
        queryParams: {
          id: this.activatedRoute.snapshot.queryParams.id,
          restaurantId: this.activatedRoute.snapshot.queryParams.restaurantId
        }
      });
    }
    this.restaurantName = this.activatedRoute.snapshot.queryParams.name;
    this.loadForm();
    this.setPageData();
    this.initializeData();
    this.filteredUser = this.guestForm.controls['guestName'].valueChanges.pipe(
      startWith(''),
      map(value => {
        this.guestName = typeof value === 'string' ? value : value?.guestName;
        return this.guestName ? this._filter(this.guestName as string) : this.userGroup.slice();
      }),
    );
    this.setHeaderData();
  }

  nameFocusOutHandler(event: any) {
    let hasABC = false;
    this.filteredUser.subscribe(users => {
      hasABC = (users as GuestModelSpa[]).some(user => user.guestName === this.guestForm.controls['guestName'].value.guestName);
    })
    if (!hasABC && !(this.guestForm.get('guestName')).errors?.required) {
      this.guestForm.controls["guestName"].setErrors({
        incorrectName: true,
      });
      //setError
    }
  }

  private _filter(value: string): GuestModelSpa[] {
    const filterValue = value.toLowerCase();
    return this.userGroup.filter(option => option.guestName.toLowerCase().includes(filterValue));
  }

  displayFn(guest: GuestModelSpa): string {
    return guest && guest.guestName ? guest.guestName : '';
  }

  setPageData() {
    this.selectedTime = 'hh:mm'
    this.time = 'Select';
    this.guestForm.controls['status'].setValue(this.currentStatus);
    this.reservationTime = [...this.setWakeUpCallTime()];
    // this.tableNumberList = [
    //   { value: "1", viewValue: "Table No. 01 (1-2 Persons)" },
    //   { value: "2", viewValue: "Table No. 02 (1-2 Persons)" },
    //   { value: "3", viewValue: "Table No. 03 (3-4 Persons)" },
    //   { value: "4", viewValue: "Table No. 04 (1-2 Persons)" },
    //   { value: "5", viewValue: "Table No. 05 (5 Persons)" },
    //   { value: "6", viewValue: "Table No. 06 (5-8 Persons)" },
    // ];
    this.tableNumberList = [
      { value: "1", viewValue: "01" },
      { value: "2", viewValue: "02" },
      { value: "3", viewValue: "03" },
      { value: "4", viewValue: "04" },
      { value: "5", viewValue: "05" },
      { value: "6", viewValue: "06" },
      { value: "5", viewValue: "07" },
      { value: "6", viewValue: "08" },
      { value: "5", viewValue: "09" },
      { value: "6", viewValue: "10" },
      { value: "5", viewValue: "11" },
      { value: "6", viewValue: "12" },
      { value: "5", viewValue: "13" },
      { value: "6", viewValue: "14" },
      { value: "5", viewValue: "15" },
      { value: "6", viewValue: "16" },
    ];

    this.peopleOpt = [
      { label: '1', value: '1' },
      { label: '2', value: '2' },
      { label: '3', value: '3' },
      { label: '4', value: '4' },
      { label: '5', value: '5' },
      { label: '6', value: '6' },
      { label: '7', value: '7' },
      { label: '8', value: '8' },
      { label: '9', value: '9' },
      { label: '10', value: '10' },

    ];

    this.reservationStatus = [
      { label: 'New Request', value: 'New Request' },
      { label: 'Confirmed', value: 'Confirmed' },
      { label: 'Seated', value: 'Seated' },
      { label: 'No Show', value: 'No Show' },
      { label: 'Cancel', value: 'Cancelled' },
    ];

  }

  initializeData() {
    this.restfullServices.getGuestListWithId()
      .subscribe(
        response => {
          if (response) {
            this.userGroup = response;
          }
        },
        () => this.globalService.showAlert(this.globalService.errorMsg));
  }

  public changeStatus(option) {
    if (option.value != "Cancelled") {
      this.previousStatus = this.currentStatus;
      this.currentStatus = option.value;
      this.guestForm.get('status')?.setValue(this.currentStatus, { emitEvent: true });
      if (!this.guestForm.dirty) {
        this.guestForm.markAsDirty();
      }
      const currentHeaderData = this.globalService.headerData$.getValue();
      if (!currentHeaderData.confirmBack) {
        this.globalService.headerData$.next({
          ...currentHeaderData,
          confirmBack: true
        });
      }
      this.cdr.detectChanges();
      // else if (option.value == "Seated" || option.value == "No Show") {
      //   this.openSnackBar("Status Updated!")
      // }
    }
    else if (option.value == "Cancelled" && this.reservationId) {
      //if cancelled ->Show pop-up -> On confirm->Update status directly
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        panelClass: "custom_dialog_container",
        width: "440px",
        data: {
          list: this.cancellationReasonList,
          title: "Cancel Reservation?",
          message:
            "This action will remove the reservation from the schedule.",
          type: "confirmCancellation",
        },
      });

      dialogRef
        .afterClosed()
        .pipe(filter((result) => !!result))
        .subscribe((response) => {
          //Display toaster
          if (response.value = true) {
            //Cancel reservation API
            this.previousStatus = this.currentStatus;
            this.currentStatus = option.value;
            this.guestForm.get('status')?.setValue(this.currentStatus, { emitEvent: true });
            let payload = {
              id: this.guestForm.controls['id'].value,
              status: this.guestForm.controls['status'].value,
              cancellationReason: response.reason
            };
            this.globalService.showLoader$.next(true);
            this.restfullServices.updateReservationStatus(payload).subscribe(response => {
              if (response) {
                this.isCancelled = true;

                if (!this.guestForm.dirty) {
                  this.guestForm.markAsDirty();
                }
                const currentHeaderData = this.globalService.headerData$.getValue();
                if (currentHeaderData.confirmBack) {
                  this.globalService.headerData$.next({ ...currentHeaderData, confirmBack: false });
                }
                this.cdr.detectChanges();
                this.openSnackBar("Reservation cancelled!");
                this.sendReservationNotification(this.guestForm.controls['status'].value)
                  .subscribe({
                    next: () => {
                      console.log("Notification sent successfully");
                      this.globalService.showLoader$.next(false);
                      this.loadForm();
                    },
                    error: err => {
                      console.error("Notification failed:", err);
                      // Still reload if you want
                      this.globalService.showLoader$.next(false);
                      this.loadForm();
                    }
                  });
                // this.router.navigate(['/pages/food-beverages/orders'], {
                //   queryParams: { id: this.activatedRoute.snapshot.queryParams.restaurantId }
                // });
                this.globalService.showLoader$.next(false);
              }
            });
          }
          else {
            this.guestForm.get('status')?.setValue(this.previousStatus, { emitEvent: true });
            this.cdr.detectChanges();
          }
        });
    };
  }
  private openSnackBar(message: string) {
    this.snackBar.openFromComponent(SnackBarComponent, {
      panelClass: ["custom-snackbar"],
      horizontalPosition: "right",
      verticalPosition: "top",
      data: {
        svgIcon: "check-circle",
        message,
      },
    });
  }


  loadForm() {
    this.createForm();
    this.activatedRoute.queryParams.subscribe((res: any) => {
      if (res) {
        //console.log(res)
        let data = {};
        if (res.orderNumber) {
          this.reservationId = res.orderNumber;
          data = {
            id: this.reservationId
          }
        }
        else {
          this.reservationId = res.id;
          data = {
            id: this.reservationId
          }
        }
        if (this.reservationId) {
          this.restfullServices.getReservationById(data).subscribe((res) => {
            //console.log(res)
            if (res.status == "Cancelled") {
              this.currentStatus = "Cancelled"
            }
            else {
              this.currentStatus = res.status;
            }
            this.isCancelled = this.currentStatus == "Cancelled" ? true : false;
            this.cancellationReason = res.cancellationReason;
            this.reservationStatus = this.reservationStatus.filter(x => x.value != res.status);
            this.reservationDate = this.datePipe.transform(res.dateAndTime, 'yyyy-MM-dd');
            this.guestForm.controls["id"].setValue(Number(res?.id));
            this.guestForm.controls["guestName"].setValue(res?.guestName);
            this.guestForm.controls["guestAspeople"].setValue(String(res?.people));
            this.guestForm.controls['selectedTime'].setValue(this.convertTimeTo24(this.datePipe.transform(res?.dateAndTime, 'shortTime')));
            //this.guestForm.controls["selectedTime"].setValue(res?.time);
            this.guestForm.controls["reservation_Date"].setValue(this.reservationDate);
            this.guestForm.controls["notes"].setValue(res?.note);
            this.guestForm.controls["tableNo"].setValue(res?.tableNumber);
            this.guestForm.controls["status"].setValue(this.currentStatus);
          });
        }
        this.subscribeToFormChanges();
        this.cdr.detectChanges();
      }
    });

  }
  subscribeToFormChanges() {
    if (this.guestForm) {
      this.guestForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
        if (this.guestForm.dirty) {
          const currentHeaderData = this.globalService.headerData$.getValue();
          if (!currentHeaderData.confirmBack) {
            this.globalService.headerData$.next({ ...currentHeaderData, confirmBack: true });
          }
        }
      });
    }
  }

  public createForm() {
    this.guestForm = this.fb.group({
      id: [null],
      guestName: ['', Validators.required],
      guestAspeople: [null],
      selectedTime: [null],
      reservation_Date: [this.datePipe.transform(new Date(), 'dd/MM/YYYY')],
      sdate: [this.datePipe.transform(new Date(), 'dd/MM/YYYY')],
      notes: [null],
      tableNo: [null],
      bookedOpt: [''],
      status: [''],
    });
  }

  setWakeUpCallTime() {
    let hourArr = [
      // { value: 'anytime', viewValue: 'Anytime' }
    ];
    for (var i = 1; i <= 23; i++) {
      hourArr.push({
        value: (i < 10 ? "0" + i + ":00 am" : (i > 12 ? i - 12 + ":00 pm" : i + ":00 am")),
        viewValue: (i < 10 ? "0" + i + ":00 am" : (i > 12 ? i - 12 + ":00 pm" : i + ":00 am"))
      });
    }
    return hourArr;
  }

  save(type) {
    if (type == 'save') {
      if (this.guestForm.invalid) {
        return
      }
      //Save Table resevation data to db api
      let payload = {
        id: 0,
        guestId: +this.guestForm.controls['guestName'].value.id,
        guests: this.guestForm.controls['guestAspeople'].value,
        time: this.convertTime(this.guestForm.controls['selectedTime'].value),
        date: this.datePipe.transform(this.guestForm.controls['reservation_Date'].value, 'dd/MM/YYYY'),
        note: this.guestForm.controls['notes'].value,
        tableNumber: this.guestForm.controls['tableNo'].value,
        status: this.guestForm.controls['status'].value,
        isReserved: 0,
        restaurantId: this.activatedRoute.snapshot.queryParams.restaurantId,
        timeZoneId: this.getUserTimeZone()
      };
      this.globalService.showLoader$.next(true);
      this.restfullServices.addTableReservation(payload).subscribe(response => {
        if (response) {
          this.sendReservationNotification(this.guestForm.controls['status'].value)
            .subscribe({
              next: () => {
                console.log("Notification sent successfully");
                this.globalService.showLoader$.next(false);
              },
              error: err => {
                this.globalService.showLoader$.next(false);
              }
            });
          this.openSnackBar("Reservation Added Successfully.");
          this.globalService.showLoader$.next(false);
          this.router.navigate(['/pages/food-beverages/orders'], {
            queryParams: { id: this.activatedRoute.snapshot.queryParams.restaurantId }
          });
        }
      });
    } else {
      let payload = {
        id: this.guestForm.controls['id'].value,
        guestId: +this.guestForm.controls['guestName'].value.id,
        guests: +this.guestForm.controls['guestAspeople'].value,
        time: this.convertTime(this.guestForm.controls['selectedTime'].value),
        date: this.datePipe.transform(this.guestForm.controls['reservation_Date'].value, 'dd/MM/YYYY'),
        note: this.guestForm.controls['notes'].value,
        tableNumber: this.guestForm.controls['tableNo'].value,
        status: this.guestForm.controls['status'].value,
        isReserved: 1,
        restaurantId: this.activatedRoute.snapshot.queryParams.restaurantId,
        timeZoneId: this.getUserTimeZone()
      };
      this.globalService.showLoader$.next(true);
      this.restfullServices.addTableReservation(payload).subscribe(response => {
        if (response) {
          const currentHeaderData = this.globalService.headerData$.getValue();
          if (currentHeaderData.confirmBack) {
            this.globalService.headerData$.next({ ...currentHeaderData, confirmBack: false });
          }
          // this.sendReservationNotification(this.guestForm.controls['status'].value);
          //this.openSnackBar("Reservation cancelled!");

          if (this.previousStatus != "" && this.previousStatus != this.currentStatus) {
            if (this.currentStatus == "Confirmed") {
              this.openSnackBar("Reservation Confirmed!");
              this.previousStatus = "";
            }
            else if (this.currentStatus == "Seated" || this.currentStatus == "No Show") {
              this.openSnackBar("Status Updated!");
              this.previousStatus = "";
            }
          }
          else {
            this.openSnackBar("Reservation Updated!")
          }
          //Don't navigate back to reservation list
          // this.router.navigate(['/pages/food-beverages/orders'], {
          //   queryParams: { id: this.activatedRoute.snapshot.queryParams.restaurantId }
          // });
          this.sendReservationNotification(this.guestForm.controls['status'].value)
            .subscribe({
              next: () => {
                console.log("Notification sent successfully");
                this.loadForm();
                this.globalService.showLoader$.next(false);
              },
              error: err => {
                console.error("Notification failed:", err);
                // Still reload if you want
                this.loadForm();
                this.globalService.showLoader$.next(false);
              }
            });
          this.globalService.showLoader$.next(false);
        }
      });
    }
  }
  getUserTimeZone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  public sendReservationNotification(status: string) {
    let model: OneSignalNotificationModel;

    if (status === "Confirmed") {
      model = {
        url: "/#/bookings",
        title: this.restaurantName,
        message: `Table reservation confirmed.
Your table for ${this.guestForm.controls['guestAspeople'].value} at ${this.restaurantName} is confirmed for 
${this.datePipe.transform(this.guestForm.controls['reservation_Date'].value, 'dd/MM/YYYY')} at 
${this.convertTime(this.guestForm.controls['selectedTime'].value).toString().toUpperCase()}. 
We look forward to welcoming you.`,
        icon: "../../assets/images/OBRLogo.png",
        orderNumber: this.activatedRoute.snapshot.queryParams.id,
        serviceName: "table_reservation"
      };
    }

    if (status === "Cancelled") {
      model = {
        url: "/#/bookings",
        title: this.restaurantName,
        message: `Table reservation cancelled.
Your table reservation on 
${this.datePipe.transform(this.guestForm.controls['reservation_Date'].value, 'dd/MM/YYYY')} 
at ${this.getFormControl('selectedTime').value} has been cancelled. 
Please contact the front desk for assistance.`,
        icon: "../../assets/images/OBRLogo.png",
        orderNumber: this.activatedRoute.snapshot.queryParams.id,
        serviceName: "table_reservation"
      };
    }
    // If no model was created, return an observable that emits null and completes.
    if (!model) {
      return of(null);
    }

    // Return the Observable from the service (don't subscribe here).
    return this.restfullServices.oneSignalTransactionalNotification(model);
  }

  // public sendReservationNotification(status: string) {
  //   if (status == "Confirmed") {
  //     let confirmedModel: OneSignalNotificationModel = { url: "/#/bookings", title: this.restaurantName, message: "Table reservation confirmed.\r\nYour table for " + +this.guestForm.controls['guestAspeople'].value + " at " + this.restaurantName + " is confirmed for " + this.datePipe.transform(this.guestForm.controls['reservation_Date'].value, 'dd/MM/YYYY') + " at " + this.convertTime(this.guestForm.controls['selectedTime'].value).toString().toUpperCase() + ". We look forward to welcoming you.", icon: "../../assets/images/OBRLogo.png", orderNumber: this.activatedRoute.snapshot.queryParams.id, serviceName: "table_reservation" }
  //     setTimeout(() =>
  //       this.restfullServices.oneSignalTransactionalNotification(confirmedModel).subscribe(() => {
  //         window.location.reload;
  //       }), 1000)
  //   }
  //   if (status == "Cancelled") {
  //     let cancelledModel: OneSignalNotificationModel = { url: "/#/bookings", title: this.restaurantName, message: "Table reservation cancelled.\r\nYour table reservation on " + this.datePipe.transform(this.guestForm.controls['reservation_Date'].value, 'dd/MM/YYYY') + " at " + this.getFormControl('selectedTime').value + " has been cancelled. Please contact the front desk for assistance.", icon: "../../assets/images/OBRLogo.png", orderNumber: this.activatedRoute.snapshot.queryParams.id, serviceName: "table_reservation" }
  //     setTimeout(() =>
  //       this.restfullServices.oneSignalTransactionalNotification(cancelledModel).subscribe(() => {
  //         window.location.reload;
  //       }), 1000)
  //   }

  // }
  public getFormControl(formControlName: string) {
    return this.guestForm.get(formControlName);
  }

  startDate(type: string, event: MatDatepickerInputEvent<Date>) {
    this.guestForm.controls['sdate'].setValue(this.datePipe.transform(event.value, 'dd/MM/YYYY'));
  }

  /** Set Date Format */
  getDate(toDate: Date) {
    return (toDate.getMonth() + 1) + '/' + toDate.getDate() + '/' + toDate.getFullYear();
  }

  convertTime(input: string) {
    let time = input.split(":");
    let hour = time[0];
    let min = time[1];
    let suffix = "";
    if (+hour > 12) {
      hour = (+hour - 12).toString();
      suffix = "pm";
    }
    else if (+hour == 12) {
      suffix = "pm";
    }
    else
      suffix = "am";
    //hour = +hour<10?"0"+hour:hour;
    return hour + ":" + min + " " + suffix;
  }

  convertTimeTo24(input: string) {
    let hours = Number(input.match(/^(\d+)/)[1]);
    let minutes = Number(input.match(/:(\d+)/)[1]);
    const AMPM = input.match(/\s(.*)$/)[1];
    if (AMPM.toLowerCase() === "pm" && hours < 12) hours = hours + 12;
    if (AMPM.toLowerCase() === "am" && hours == 12) hours = hours - 12;

    let sHours = hours.toString();
    let sMinutes = minutes.toString();
    if (hours < 10) sHours = "0" + sHours;
    if (minutes < 10) sMinutes = "0" + sMinutes;

    return `${sHours}:${sMinutes}`;
  }


  private setHeaderData() {
    this.selectedIndex = 1;
    const config1: any = {
      showBackButton: true,
      navigationPage: '/pages/food-beverages/orders',
      queryParams: { id: this.activatedRoute.snapshot.queryParams.restaurantId }
    };
    const config: HeaderModel = {
      headerTitle: "",
      showBackButton: true,
      info1: '',
      info2: '',
      confirmBack: false,
      backActionTitle: 'Unsaved changes',
      backActionMsg: 'Are you sure you want to leave this page? Unsaved changes will be lost.',
      navigationPage: '/pages/food-beverages/orders',
      queryParams: { id: this.activatedRoute.snapshot.queryParams.restaurantId }
    };

    this.globalService.isMobile
      ? config.headerTitle = 'Reservation details'
      : config.info1 = 'Reservation details';

    this.globalService.headerData$.next(config);
    this.globalService.tabIndexSet.next(this.selectedIndex)
    this.restfullServices.setLocalStorage('tabindex', this.selectedIndex);
  }

  startTour() {
    this.introJS.setOptions({
      steps: [
        {
          tooltipClass: "intro-step-add_reservation",
          title: "ADD NEW RESERVATION",
          element: document.getElementById('place_order'),
          intro: "Well done! This is where you can add a new reservation for your customers by entering all the necessary information.",
          position: 'right'
        },


      ],
      disableInteraction: true,
      showBullets: false,
      showButtons: true,
      exitOnOverlayClick: false,
      keyboardNavigation: true,
      scrollToElement: true,
      scrollTo: 'tooltip',
    });
    this.introJS.start();
    this.introJS.onbeforechange((targetElement) => {
      this.introJS.refresh();
    });

    setTimeout(() => {
      if (document.querySelector(".intro-skip")) {
        let skipButton = document.querySelector(".intro-skip");
        skipButton.addEventListener('click', this.skipTour.bind(this));
      }

      if (document.querySelector(".introjs-skipbutton")) {
        let closeButton = document.querySelector(".introjs-skipbutton");
        closeButton.addEventListener('click', this.closeStep.bind(this));
      }
    }, 100);
  }

  skipTour(): void {
    this.introJS.exit();
    this.restfullServices.removeLocalStorage('isTourRunning');
    window.location.href = '#/pages/food-beverages';
  }

  closeStep(): void {
    window.location.href = '#/pages/food-beverages';
  }
  showCancellation(cancellationReason: string) {
    if (cancellationReason == "Other") {
      return "Cancellation reason not specified."
    } else if (cancellationReason == "Guest’s request") {
      return "Cancellation requested by guest."
    }
    else {
      return cancellationReason;
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (!this.globalService.isMobile$.getValue()) {
        const isTourRunning = this.restfullServices.getLocalStorage('isTourRunning');
        const isFirstLogin = this.restfullServices.getLocalStorage('IsFirstLogin');
        const guidedTourAddReservationFlag = this.restfullServices.getLocalStorage('guidedTourAddReservationFlag');
        if (isTourRunning == 'true' && isFirstLogin == 'false' && guidedTourAddReservationFlag == 'false') {
          this.restfullServices.setLocalStorage('guidedTourAddReservationFlag', 'true');
          this.startTour();
          this.cdr.detectChanges();
        }
      }
    }, 500);
  }
}

